import Text from 'components/base/Text';
import React from 'react';
import LogoWithDudeWrapper from './LogoWithDudeWrapper';

export const RequestInvitationView = ({ email }) => (
  <LogoWithDudeWrapper>
    <Text size='x-x-x-large' pt='7rem' weight='300'>
      Hello stranger...
    </Text>
    <Text size='large' pt='2rem' weight='400' align='center'>
      We did not recognize your email: {email}
    </Text>
    <Text size='large' pt='1rem' weight='400' align='center'>
      Ask your admin or teammates to invite you to your company’s LinearB
      Account
    </Text>
  </LogoWithDudeWrapper>
);
